export default function(totalCarb) {
  return {
    type: "SET_TOTAL_CARB",
    totalCarb
  }
}



// WEBPACK FOOTER //
// ./src/actions/setMacrosTotals/setCarbTotal.js